// @flow
import { ImagesActionTypes } from './constants';

type ImagesAction = { type: string, payload: {} | string };

// common success
export const imagesApiResponseSuccess = (actionType: string, data: any): ImagesAction => ({
    type: ImagesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const imagesApiResponseError = (actionType: string, error: string): ImagesAction => ({
    type: ImagesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getImages = (ownerId: string): ImagesAction => ({
    type: ImagesActionTypes.GET_IMAGES,
    payload: { ownerId },
});

export const resetImages = (): ImagesAction => ({
    type: ImagesActionTypes.RESET,
    payload: {},
});

